import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchCreatedScenario,
  fetchModuleSequence,
  fetchDynamicBreadcrumbs,
  fetchOpportunityToColorMap,
  fetchScenarioAccessConfig,
  fetchScenarioDetails
} from '../api/simulator-module-api';
import { ISimulatorHomeState } from '../types/scenario-state';

const getModuleSequence = createAsyncThunk(
  '/api/module_seq',
  async (sourceId: number) => {
    const response = await fetchModuleSequence(sourceId);
    const moduleSequence = response.data;
    const moduleNameToModuleIdMap = moduleSequence.reduce<
      ISimulatorHomeState['moduleNameToModuleIdMap']
    >(
      (previousValue, currentValue) => ({
        ...previousValue,
        [currentValue.module.name]: currentValue.module.pk_id
      }),
      {}
    );
    return {
      moduleSequence,
      moduleNameToModuleIdMap
    };
  }
);

const getDynamicBreadcrumbs = createAsyncThunk(
  '/api/module_sequence',
  async (sourceId: number) => {
    const response = await fetchDynamicBreadcrumbs(sourceId);
    const dynamicBreadcrumbs = response.data;
    return dynamicBreadcrumbs;
  }
);

const getOpportunityToColorMap = createAsyncThunk(
  '/api/home/getOpportunityToColorMap',
  async (sourceId: number) => {
    const response = await fetchOpportunityToColorMap(sourceId);
    return response.data;
  }
);

/**
 * Retrieves the details of scenario and its summary
 */
const getScenarioDetails = createAsyncThunk(
  '/api/home/scenarioDetails',
  async ({
    scenarioId,
    sourceId
  }: {
    scenarioId: number;
    sourceId: number;
  }) => {
    const response = await fetchScenarioDetails(sourceId, scenarioId);
    const scenarioAccessConfig = await fetchScenarioAccessConfig(
      sourceId,
      scenarioId
    );
    return {
      scenarioDetails: response.data,
      scenarioAccessConfig: scenarioAccessConfig.data.access_config
    };
  }
);

/**
 * Retrieves the details of scenario and its summary
 */
const getListOfScenariosForTable = createAsyncThunk(
  '/api/home/getListOfScenariosForTable',
  async ({ sourceId }: { sourceId: number }) => {
    const response = await fetchCreatedScenario(sourceId);
    return response;
  }
);

/**
 * Retrieves the access configuration for the given scenario for logged in user
 */
const getAccessConfigForScenario = createAsyncThunk(
  '/api/home/getAccessConfigForScenario',
  async ({
    sourceId,
    scenarioId
  }: {
    sourceId: number;
    scenarioId: number;
  }) => {
    const response = await fetchScenarioAccessConfig(sourceId, scenarioId);
    return response.data.access_config;
  }
);

export {
  getModuleSequence,
  getDynamicBreadcrumbs,
  getOpportunityToColorMap,
  getScenarioDetails,
  getListOfScenariosForTable,
  getAccessConfigForScenario
};
